import {FILTERS_HELP_TEXTS as sharedFiltersHElpTexts} from '../common/filtersHelpTexts.js'

// Define only the filters help texts that are different from the common ones
export const FILTERS_HELP_TEXTS = {...sharedFiltersHElpTexts}
